import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {

    layoutMode = 'horizontal';

    layoutColor = 'light';

    darkMenu = false;

    isRTL = false;

    inputStyle = 'outlined';

    ripple = true;

    constructor() {
        const translate = inject(TranslateService);

        translate.setFallbackLang('sk');
    }

    ngOnInit() {
    }
}
